const getters = {
  fullname: state => {
    try {
      return state.userProfile.profile.name;
    } catch (e) {
      return false;
    }
  },
  isUser: state => !!state.currentUser,
  researchSession: state => {
    return state.userProfile.researchSession;
  },
  userId: state => {
    if (state.currentUser) {
      return state.currentUser.uid;
    } else {
      return null;
    }
  },
  lastWorkspaceId: state => {
    return state.userProfile ? state.userProfile.lastWorkspaceId : null;
  },
  avatar: state => {
    try {
      return state.userProfile.profile.avatar;
    } catch (e) {
      return false;
    }
  },
  profile: state => {
    if (state.userProfile.user) {
      return state.userProfile.profile;
    } else {
      return false;
    }
  },
  userEmail: state => (state.currentUser ? state.currentUser.email : null)
};

export default getters;
